export const stripeFont = { src: 'https://fonts.googleapis.com/css?family=B612', name: 'no_B612' };

export const stripeKeys = {
  dev: 'pk_test_EHi0aNDNOYDmiCu9nztUM6FF',
  prod: 'pk_live_tsjGtpxdkR8HtjLZyM7QX7Xy'
};
